import {
    ClickElement,
    ClickType,
    GA4EventName,
    GA4FeatureCategory,
    trackAnalyticsEvent,
} from '@jsmdg/tracking';

async function trackShowReviews(): Promise<void> {
    await window.yieldToMainThread();
    trackAnalyticsEvent({
        eventData: {
            eventName: GA4EventName.ViewReviewBlock,
            feature_category: GA4FeatureCategory.ProductDetailInformation,
        },
    });
}

async function trackDisplayAllClicked(): Promise<void> {
    await window.yieldToMainThread();
    trackAnalyticsEvent({
        eventData: {
            eventName: GA4EventName.ClickButton,
            feature_category: GA4FeatureCategory.ProductDetailInformation,
            click_type: ClickType.Select,
            click_element: ClickElement.OpenReviewSection,
            click_text: 'alle Anzeigen',
        },
    });
}

async function trackReadMoreClicked(): Promise<void> {
    await window.yieldToMainThread();
    trackAnalyticsEvent({
        eventData: {
            eventName: GA4EventName.ClickTextLink,
            feature_category: GA4FeatureCategory.ProductDetailInformation,
            click_element: ClickElement.OpenReviewSection,
            click_text: 'Mehr lesen',
        },
    });
}

async function trackOpenReviewSectionClicked(
    reviews: { totalReview: number } | null | undefined,
): Promise<void> {
    await window.yieldToMainThread();
    trackAnalyticsEvent({
        eventData: {
            eventName: GA4EventName.ClickTextLink,
            feature_category: GA4FeatureCategory.ProductDetailInformation,
            click_element: ClickElement.OpenReviewSection,
            click_text: `${reviews?.totalReview ?? 0} Bewertungen`,
        },
    });
}

async function trackNextClicked(): Promise<void> {
    await window.yieldToMainThread();
    trackAnalyticsEvent({
        eventData: {
            eventName: GA4EventName.ClickButton,
            feature_category: GA4FeatureCategory.ProductDetailInformation,
            click_type: ClickType.SlideNext,
            click_element: ClickElement.SlideReviewSection,
            click_text: 'next',
        },
    });
}

async function trackPrevClicked(): Promise<void> {
    await window.yieldToMainThread();
    trackAnalyticsEvent({
        eventData: {
            eventName: GA4EventName.ClickButton,
            feature_category: GA4FeatureCategory.ProductDetailInformation,
            click_type: ClickType.SlidePrevious,
            click_element: ClickElement.SlideReviewSection,
            click_text: 'prev',
        },
    });
}

export {
    trackDisplayAllClicked,
    trackNextClicked,
    trackOpenReviewSectionClicked,
    trackPrevClicked,
    trackReadMoreClicked,
    trackShowReviews,
};
